import { Controller, FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import { Sizes } from "shared/types/mantine";
import { MaskStyledInput } from "../_masks/MaskStyledInput";

type Props = {
  name: string;
  control: any;
  mask: string;
  size?: Sizes;
  label?: string;
  required?: boolean;
  placeholder?: string;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  disabled?: boolean;
};

const rules = (required?: boolean) => ({
  required: required
    ? {
        value: true,
        message: "Поле обязательно для заполнения",
      }
    : {},
  pattern: {},
});

export const CustomInput = ({
  name,
  control,
  size,
  required,
  mask,
  error,
  label,
  placeholder,
  disabled,
}: Props) => (
  <Controller
    name={name}
    control={control}
    rules={rules(required) as any}
    render={({ field: { onChange, onBlur, value = "" } }) => {
      return (
        <MaskStyledInput
          onBlur={onBlur}
          value={value}
          label={label}
          error={error as any}
          mask={mask}
          definitions={{
            "#": /[0-9]/,
          }}
          placeholder={placeholder}
          onAccept={onChange}
          required={required}
          onChange={onChange}
          size={size as any}
          overwrite
          disabled={disabled}
        />
      );
    }}
  />
);
